<template>
    <BaseWidget :title="widget.title">
        <template v-if="widget.content.no_chest_found">
            <div class="flex flex-col">
                <img :src="'/img/gamification/chest_not_found.svg'" alt="" class="h-40" />
            </div>
            <div class="mt-3 text-gray-600">
                {{ $t('messages.new_treasure_chest_when_message') }}
            </div>
        </template>
        <template v-else-if="isClosed">
            <div class="flex flex-col" @click="openChest()">
                <TreasureChest :type="widget.content.type" class="h-40 cursor-pointer" />
            </div>
        </template>
        <template v-else>
            <div
                :class="{
                    'md:grid md:grid-cols-2 md:gap-6': widget.content.items,
                }"
            >
                <div class="flex flex-col">
                    <div class="mt-5 inline-block">
                        <TreasureChest :type="widget.content.type" class="h-40" is-open />
                        <div class="mt-1">
                            <div class="flex justify-between items-center">
                                <div>
                                    <BadgePill color="green" v-show="widget.content.experience_amount">
                                        {{ widget.content.experience_amount }}
                                    </BadgePill>
                                </div>
                                <div>
                                    <BadgePill color="yellow" v-show="widget.content.coins_amount">
                                        {{ widget.content.coins_amount }}
                                    </BadgePill>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-5" v-if="widget.content.items">
                    <div class="grid grid-cols-3 lg:grid-cols-3 md:gap-6">
                        <div v-for="(item, index) in widget.content.items" :key="index">
                            <inertia-link :href="widget.content.inventory_url">
                                <div class="relative h-40">
                                    <img :src="item.image_path" alt="" class="absolute" />
                                </div>
                            </inertia-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-3 text-gray-600">
                {{ $t('messages.new_treasure_chest_when_message') }}
            </div>
        </template>

        <Modal :show="openModal" @close="openModal = false">
            <div class="mt-1">
                <div class="flex justify-center">
                    <h2 class="inline-block text-3xl">
                        {{ $t('messages.congratulations!') }}
                    </h2>
                </div>
                <div class="flex justify-center mt-5">
                    <div>
                        <TreasureChest :type="widget.content.type" class="h-40" is-open />
                        <div class="mt-1">
                            <div class="flex justify-between items-center">
                                <div>
                                    <BadgePill color="green" v-show="widget.content.experience_amount">
                                        {{ widget.content.experience_amount }}
                                    </BadgePill>
                                </div>
                                <div>
                                    <BadgePill color="yellow" v-show="widget.content.coins_amount">
                                        {{ widget.content.coins_amount }}
                                    </BadgePill>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="text-2xl">
                        {{
                            $tc('messages.you_have_obtained__X coins', widget.content.coins_amount, {
                                coins: widget.content.coins_amount,
                            })
                        }}
                    </div>
                </div>
            </div>
            <div class="mt-5" v-if="items.length">
                <div class="grid grid-cols-3 lg:grid-cols-6 md:gap-6">
                    <div v-for="(item, index) in items" :key="index">
                        <inertia-link :href="widget.content.inventory_url">
                            <div class="relative h-40">
                                <img :src="'/img/gamification/shine.svg'" alt="" class="absolute animate-spin-slow" />
                                <img :src="item.image_path" alt="" class="absolute" />
                            </div>
                            <div>
                                {{ item.name }}
                            </div>
                        </inertia-link>
                    </div>
                </div>
            </div>
        </Modal>
    </BaseWidget>
</template>

<script>
import BaseWidget from '@/components/Widgets/BaseWidget.vue';
import Modal from '@/components/Modal.vue';
import BadgePill from '@/components/BadgePill.vue';
import { Howl } from 'howler';
import TreasureChest from '@/components/TreasureChest.vue';
import axios from 'axios';

export default {
    name: 'ChestWidget',
    props: {
        widget: {
            required: true,
            type: Object,
        },
    },
    data() {
        return {
            openModal: false,
            items: this.widget.content.items,
            isClosed: this.widget.content.is_closed,
            submitting: false,
        };
    },
    methods: {
        openChest() {
            if (this.submitting) {
                return;
            }
            this.submitting = true;
            axios
                .patch(this.widget.content.open_chest_url, {
                    type: this.widget.content.type,
                })
                .then((response) => {
                    if (response.data.open_chest) {
                        this.items = response.data.items;
                        this.isClosed = false;
                        this.showModal();
                    }
                });
        },
        showModal() {
            this.openModal = true;

            setTimeout(() => {
                const sound = new Howl({
                    src: ['/assets/gamification/open_chest.mp3'],
                });
                sound.play();
            }, 1000);
        },
    },
    components: {
        BaseWidget,
        Modal,
        BadgePill,
        TreasureChest,
    },
};
</script>
